export const RIGHT_MENU = {
    SHOW: 'RIGHT_MENU.SHOW'
}